import PillButton from 'components/buttons/PillButton';
import RemoveButton from 'components/buttons/RemoveButton';
import PillButtonText from 'components/text/PillButtonText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FilterButton: FunctionComponent<Props> = ({
    className = '',
    hasValue = false,
    onClick,
    onRemove,
    testId = TEST_ID,
    text
}) => {
    const selectedClass = hasValue ? styles.selected : '';

    const handleOnclick = () => {
        onClick?.();
    };

    return (
        <PillButton
            className={`${selectedClass} ${styles.filterButton} ${className}`}
            onClick={handleOnclick}
            testId={testId}>
            <PillButtonText text={text} />

            {hasValue && onRemove && (
                <RemoveButton className={styles.removeButton} onClick={onRemove} />
            )}
        </PillButton>
    );
};

export default FilterButton;
